"use client"
import { ReactNode } from "react";
import Image from "next/image";
import Button from "@/components/common/button/Button";
import { RecursiveTranslations } from "@/data/types";
import { h2Style, paragraphStyle } from "@/data/styles";

import image from '@/assets/images/Rivera_the_valley_Latest_project.webp'
import { ArrowRightIcon } from "@/components/icons";


type Props = {
  translations: RecursiveTranslations
}

export default function LatestLaunch({ translations }: Props) {
  return (
    <div className="w-full flex flex-col xl:flex-row">
      <div className="w-full xl:flex-1 bg-[#EBE1D4]">
        <div className="max-w-[1440px] mx-auto px-[20px] md:px-[50px] py-[59px] flex flex-col gap-[30px] text-[#1B1D2B]">
          <div className="max-w-[900px] xl:max-w-[613px] ml-0 xl:ml-auto flex flex-col gap-[30px] items-start">
            <h2 className={h2Style}>{translations?.title as string}</h2>
            <p className={paragraphStyle}>{translations?.paragraph as string}</p>
            <Button 
              rightIcon={<ArrowRightIcon color="white" width={20} height={20} />}
              onClick={() => {
                const contactSection = document.getElementById("contact-form");
                if (contactSection) {
                  contactSection.scrollIntoView({ behavior: "smooth", block: "center" });
                }
              }}
            >
              {translations?.buttonLabel as ReactNode}
            </Button>
          </div>
        </div>
      </div>

      <div className="hidden xl:block w-full xl:w-[50%] relative min-h-[500px] xl:min-h-full bg-[#cabeb5]">
        <Image src={image} alt="latest launch" fill className="object-cover" loading="lazy" />
      </div>
    </div>
  )
}

